export default {
  categoryInfo: {
    mainTitle: 'İş Yeri (Paket) Sigortası ',
    description: {
      title: 'İş Yeri (Paket) Sigortası Nedir?',
      content: [
        'İş yeri sigortası, işyerinizde bulunan makine, tesisat veya 3. Şahıs emtealarını oluşabilecek risklere karşı güvence altına almaktadır.',
        'İş yeri sigortası ile işyeriniz de oluşabilecek riskleri düşünmeden sadece işinize odaklanabilirsiniz.',
        'İş yeri sigortası fiyatlarını değerlendirerek işletmenizi risklere karşı koruma altına alabilirsiniz.'
      ]
    },
    subContent: {
      title: 'İş Yeri (Paket) Sigortası Ne İşe Yarar?',
      content: [
        {
          paragraph: null,
          subList: [
            'İş yeri sigortası iş yerinizde kazaen veya size karşı kasti yapılan maddi hasarları poliçenizde belirlemiş olduğunuz limitler dâhilinde karşılamaktadır.',
            'İş yerinizde bulunduğunuz sırada veya iş yeriniz kapalıyken meydana gelebilecek zararları güvence altına almanızı sağlar.',
            'Doğal afetlerin iş yerinize vereceği zararları karşılar.',
            'İş yeri sigortası sermayenizi koruyarak yeni yapacağınız yatırımlara olanak sağlar.',
            'Hırsızlık durumundan kira kaybına kadar oluşacak birçok durumuna karşı güvence sunarak meydana gelebilecek risklere karşı teminat sunar.'
          ]
        }
      ]
    }
  },
  faqTitle: 'Sıkça Sorulan Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'İş Yeri Sigortası Zorunlu Mu?',
      content: [
        {
          paragraph:
            'İş yeri sigortası zorunlu bir sigorta ürünü değildir. Yalnız biz her ne kadar kontrollüde olsak, riskler her zaman beklenmedik anda ortaya çıkar.',
          subList: null
        },
        {
          paragraph:
            'Örnek olarak iş yeriniz kapalıyken, su basabilir veya elektrik sigortasından yangın çıkabilir. Senelerce çalışıp çabaladığınız emek verdiğiniz bir yerin sadece bir ihmal yüzüne yok olmasını istemezsiniz. Risk almak yerine iş yeri sigortası alarak ekmek teknenizi koruma altına alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Hem iş yerinizi hem de çalışanlarınızı güvence altına almak için hemen iş yeri sigortası teklifi alın, primleri değerlendirin.',
          subList: null
        }
      ]
    },
    {
      title: 'İş Yeri Sigortasında Emtea Nedir?',
      content: [
        {
          paragraph:
            'Emtea, iş yerinizde bulunan hammadde ve bu hammaddeden üretilmiş mallardır.',
          subList: null
        }
      ]
    },
    {
      title: 'İş Yeri Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'İş yeri sigortasının kapsamı almış olduğunuz poliçe teminatlarına göre belirlenmektedir. Genel olarak iş yerinde oluşan hırsızlık, sel veya su baskınları, makine kırılması ve yangın gibi riskleri kapsamaktadır. İş yeri sigortası yaptırarak, iş yerinizi bu ve daha birçok riske karşı güvence altına alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'İş Yeri Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph: 'İş yeri sigortası teminatları ana teminatlar ve ek teminatlar olmak üzere 2’ye ayrılmaktadır. Ana teminatlar;',
          subList: [
            'Hırsızlık',
            'Sel veya su baskınları',
            'Elektrik hasarları,',
            'Cam kırılması',
            'Dolu hasarları',
            'Makine kırılması',
            'Kara, hava ve deniz taşıtlarının çarpması',
            'Kira kaybı teminatı',
            'Kâr kaybı teminatı',
            'Yer kayması gibi teminatlardan oluşur'
          ]
        },
        {
          paragraph: 'Ek teminatlar;',
          subList: [
            'Kasa hırsızlığı,',
            'Fiziki hasarlar,',
            'Deprem ve yanardağ püskürmesi,',
            'Soğutucu cihazlarda bulunan ürünün bozulması,',
            '3. şahıs mali mesuliyet gibi teminatlardan oluşmaktadır.'
          ]
        },
        {
          paragraph:
            '** Ek teminatlar sigorta kapsamına ek prim ile eklenmektedir. Sigorta şirketlerinin sunmuş olduğu ek teminatlar farklılık gösterir. Bu sebeple meydana gelme ihtimali olan riskleri değerlendirmeli ve sizin için en iyi sigorta poliçesini seçmelisiniz. ',
          subList: null
        }
      ]
    },
    {
      title: 'İş Yeri Sigortası Teminat Dışı Durumlar Neler?',
      content: [
        {
          paragraph: 'Teminat dışı kalan haller almış olduğunuz poliçeye göre değişmektedir.',
          subList: [
            'Poliçeye ek olarak eklenmemesi durumunda ek teminatlar içerisinde bulunan maddeler teminat dışıdır.',
            'Sigortalının kasten yapmış olduğu hasarlar teminat kapsamı dışında tutulmuştur.',
            'Savaş, her türlü savaş olayları, istila, yabancı düşman hareketleri, çarpışma (Savaş ilan edilmiş olsun olmasın), iç savaş, ihtilal, isyan, ayaklanma ve bunların gerektirdiği inzibati ve askeri hareketler nedeniyle meydana gelen bütün zararlar.',
            'Herhangi bir nükleer yakıttan veya nükleer yakıtın yanması sonucu nükleer artıklardan veya bunlara atfedilen sebeplerden meydana gelen iyonlayıcı radyasyonların veya radyoaktivite bulaşmalarının ve bunların gerektirdiği askeri ve inzibati tedbirlerin sebep olduğu bütün zararlar. (Bu bentte geçen yanma deyimi kendi kendini idame ettiren herhangi bir nükleer ayrışım olayını da kapsayacaktır.)',
            'Kamu otoritesi tarafından sigortalı şeyler üzerinde yapılacak tasarruflar sebebiyle meydana gelen bütün zararlar.',
            'Yangın çıkarmaksızın; sigortalı şeylerin kendi ayıplarından, mayalanmalarından, kavrulmalarından veya bünyelerinde meydana gelen bozulmalar ile kavrulmalar nedeniyle uğradıkları zararlar.',
            'Yangın çıkarmaksızın; sigortalı şeylerin işlenmek için veya başka faydalı bir maksatla ateşe veya sıcaklığa tutulmasından, ocak veya bunun gibi ateş bulunan bir yere düşmesinden veya atılmasından veya elbise, çamaşır ve diğer eşya yanıklığı gibi alev almaksızın kavrulma veya yanmasından veya ısıtma, aydınlatma, ütüleme aletleri ile lamba, mum, sigara ve bunların benzerlerine temasından doğan zararlar.',
            'Yangın çıkarmaksızın; elektrikle çalışan her türlü motor, elektrik veya elektronik alet, cihaz, tesisat ve kordonlarının elektrik cereyanına bağlı bulundukları sırada bu cereyan yüzünden kısa devre, topraklama, voltaj iniş çıkışları ve bu yüzden ısınma ve endüksiyon cereyanı gibi nedenlerle uğrayacakları zararlar.',
            'Alçak basınç sebebiyle kapların içeri doğru çökmesi, yırtılması ve sair şekilde deformasyonu, yıpranması ile santrifüj kuvvetler ve mekanik olaylar nedeniyle sigortalı cihaz ve motorlarda meydana gelen bütün zararlar.'
          ]
        }
      ]
    },
    {
      title: 'İş Yeri Sigortası Ne Zaman Başlar?',
      content: [
        {
          paragraph:
            'İş yeri sigortası, poliçe tanzim edilmesi ardından aynı gün içerisinde başlamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'İş Yeri Sigortası İçin Gerekli Bilgiler (Evraklar) Nelerdir?',
      content: [
        {
          paragraph:
            'İş yeri poliçenizin tanziminin doğru edilebilmesi için istenen bilgilerin kesin olarak verilmesi gereklidir. Almış olduğunuz pakete göre istenen bilgilerde değişiklik görülebilir.',
          subList: [
            'Emtea bedelleri',
            'Sigortalı T.C. veya vergi kimlik numarası',
            'Dekorasyon bedelleri',
            'İşyerinde bulunan camların bedelleri',
            'Demirbaş bedelleri',
            'İşyeri metre karesi',
            'İşyeri güvenlik sistemleri bilgileri (kepenk, demir parmaklık, yangın tüpü vs)',
            'İşyeri adres bilgileri istenmektedir.'
          ]
        }
      ]
    },
    {
      title: 'İş Yeri Sigortası Alırken Dikkat Edilmesi Gerekenler Nelerdir?',
      content: [
        {
          paragraph:
            'Motor, şanzıman ve/veya difransiyel arızası durumunda bu arızanın direk sonucu neticesinde gerekebilecek sarf malzemeleri bu kapsama dahildir. (Kaza, donma ve/veya antifriz eksikliği gibi sebeplerle oluşan arızalar hariçtir.)',
          subList: null
        }
      ]
    },
    {
      title: 'İş Yeri Sigortası Alırken Dikkat Edilmesi Gerekenler Nelerdir?',
      content: [
        {
          paragraph:
            'İş yeri sigortası alırken dikkat edilmesi gereken en önemli şeyler bedeller ve teminatlardır.',
          subList: [
            'Sigorta primleri ve hasar sonucu yapılacak ödemeler bu bedeller üzerinden yapılmaktadır.',
            'Alacağınız sigorta poliçenizde yazmış olan riziko adresini kontrol etmelisiniz.',
            'İş yeri sigortası tekliflerini değerlendirirken sigorta danışmanına doğru bilgiler vermeye özen göstermeli ve poliçenizi onaylamadan önce yer alan bilgilerin doğruluğunu kontrol etmelisiniz.'
          ]
        }
      ]
    },
    {
      title: 'İş Yeri Paket Sigortası Teminat Limitleri Nasıl Belirlenir?',
      content: [
        {
          paragraph:
            'İş yeri büyüklüğü, istenen teminatlar ve iş yerinde bulunan emtea bedellerine göre belirlenmektedir.',
          subList: null
        },
        {
          paragraph:
            'İş yeri sigortası talep edilmesi takdirinde sigorta şirketi tarafından eksper yönlendirilerek değer tespiti yapılmaktadır ve rapor hazırlanarak sigorta şirketi tarafından değerlendirilmedik. Bu değerlendirme işlemi sonucunda teminat limitleri belirlenmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'İş Yeri Paket Sigortası Neden Yaptırılmalıdır?',
      content: [
        {
          paragraph: 'Doğru sigortaya sahip olmak, işletmenizi, müşterilerinizi ve gelirinizi korumaya yardımcı olabilir. İşletmeniz için farklı sigorta türlerini ve hangilerine ihtiyacınız olduğunu anlamanız bütçenizi korumak için de önemlidir.',
          subList: null
        },
        {
          paragraph: 'Bir sigorta poliçesi seçmeden önce, sigorta ihtiyaçlarınızı değerlendirmeniz gerekir. Her sigorta türüne bakmalı ve işletmenizin ihtiyaç duyduğu bir şey olup olmadığını belirlemelisiniz. Bazı sigortacılar, farklı işletme türleri için özel olarak tasarlanmış sigorta paketleri de sunabilir.',
          subList: null
        },
        {
          paragraph: 'İş yeri sigortası kapsamında sunulan ürünleri değerlendirerek, ihtiyacınıza özel planı seçmeniz hem işletmenizi hem de bütçenizi korur.',
          subList: null
        }
      ]
    },
    {
      title: 'Kimler İşyeri Sigortası Yaptırmalıdır?',
      content: [
        {
          paragraph:
            'İşyeri sigortasında bir kısıtlama bulunmamaktadır. Küçük, orta veya büyük ölçekli tüm işletmeler iş yeri sigortası yaptırabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'İşyeri Paket Sigortası Avantajlı Mı?',
      content: [
        {
          paragraph:
            'İşletmenizi iş yeri sigortası ile güvence altına almanız avantajlıdır. Oluşabilecek risk veya riskler sonucunda meydana gelebilecek maddi zararlara karşı koruma sağlar.',
          subList: null
        },
        {
          paragraph:
            'Bu riskler küçük veya büyük çaplı maddi zararlar açabilir. Tüm işletmelerin amacının kâr olmasından dolayı kimse para kaybı yaşamak istemez. İş yeri sigortası ile bu kayıpları önlediğiniz için iş yeri sigortası avantajlıdır. ',
          subList: null
        }
      ]
    },
    {
      title: 'İş Yeri Yangın Sigortası Nedir?',
      content: [
        {
          paragraph:
            'İş yeri yangın sigortası, iş yerinizde kazaen beklenmedik bir şekilde yangın çıkması durumunda oluşacak maddi hasarları poliçe kapsamında belirtilmiş limitler dâhilinde karşılayan sigorta teminatıdır.',
          subList: null
        }
      ]
    },
    {
      title: 'İş Yeri Hırsızlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'İş yerinde hırsızlık gerçekleşmesi durumunda yüklü miktarda maddi zarar görebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'İş yeri hırsızlık sigortası, iş yeri içerisinde bulunan dekorasyon, demirbaş, emtea, makine ve teçhizat gibi eşyalarınızın 3. Kişiler veya çalışanlarınız tarafından çalınma riskine karşılık güvence sağlanmaktadır.',
          subList: null
        },
        {
          paragraph:
            'Hırsızlık günümüzde sıkça karşılaştığımız durumlar arasında yer almaktadır. Öngörülmeyen bu durumlara karşı iş yeri sigortası yaptırabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'İş Yeri Adresi Değişirse İşyeri Sigortası Ne Olur?',
      content: [
        {
          paragraph:
            'İş yerinizin adresini değiştiriyorsanız sigortacınıza adres değişikliği talebinde bulunmalısınız. Adres değişikliği söz konusu ise zeyil yapılmaktadır. ',
          subList: null
        },
        {
          paragraph:
            'Sigortanızı almış olduğunuz kuruma haber vererek zeyil yapılmasını isteyebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'İş Yeri Sigortası Su Baskınını Karşılar Mı?',
      content: [
        {
          paragraph:
            'İş yeri sigortanıza su baskını teminatı ekletmeniz durumunda olası hasarlar sigorta kapsamında karşılanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'İş Yeri Sigortasında Metrekare Önemli Mi?',
      content: [
        {
          paragraph:
            'İş yeri poliçesi hesaplanırken küçük bir etkisi olsa da metrekarenin önemi vardır. ',
          subList: null
        },
        {
          paragraph:
            'İş yeri sigortanızda eksik metrekare belirtmeniz durumunda eksik sigorta almış olursunuz. Sigorta şirketleri bu durumda muafiyet uygulayabilir veya poliçenizi geçersiz sayabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'İş Yeri Sigortasında Deprem Sonucu Yangın Çıkarsa Hasar Karşılanır Mı?',
      content: [
        {
          paragraph:
            'İş yeri sigortanızda deprem teminatı bulunması durumunda deprem sonucu oluşacak hasarlar poliçe kapsamında karşılanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'İş Yeri Sigortasını Kiracılar Da Yapabilir Mi?',
      content: [
        {
          paragraph:
            'İş yeri sigortası yaptırmak isteyen kiracılar bina dışında diğer riskleri güvence altına alabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'İş Yeri Sigortasında Çilingir Hizmeti Var Mı?',
      content: [
        {
          paragraph:
            'Tüm sigorta şirketlerinde olmasa da bazı sigorta şirketleri çilingir hizmetini ücretsiz olarak müşterilerine sunmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'İş Yeri Sigortası Hesaplama Adımları Nelerdir?',
      content: [
        {
          paragraph:
            'İş yeri sigortası fiyat hesaplaması yapılırken öncelikle iş yerinizin risk analizi göz önünde bulundurulur. Yapılan analiz sonucunda iş yeriniz için en uygun teminatlar ve teminat limitleri belirlenerek iş yeri sigortası poliçeniz oluşturulur. ',
          subList: null
        },
        {
          paragraph:
            'İş yeri sigortası kapsamında işletmelere özel hazırlanan sigorta tekliflerinin kapsamı değişiklik gösterdiği gibi sigorta primleri de farklılık göstermektedir. Hesaplama sonucunda dikkat etmeniz gereken en önemli adım, teklife eklenen teminatların olası riskleri tam anlamıyla karşılıyor olabilmesidir.',
          subList: null
        },
        {
          paragraph:
            'İş yeri sigortası hesaplaması yapmak için Alokasko uzmanlarından fiyat teklifi istemeniz yeterlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'En Uygun İş Yeri Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'İş yeri sigortası fiyatları aylık olarak şirket politikaları çerçevesinde hazırlanmış olan teminatlara ve sigortalanacak emtea bedellerine göre değişmektedir. Bu bağlamda net bir fiyat vermek doğru değildir.',
          subList: null
        },
        {
          paragraph:
            'İş yeri sigortası fiyatları her işletme için farklı olabilir. En iyi sigorta poliçesine ulaşmak için teklif almalı ve sigorta şirketlerini değerlendirmelisiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'İş Yeri Sigortası Fiyat Teklifi Nasıl Alınır?',
      content: [
        {
          paragraph:
            'İş yeri sigortası almak artık çok daha kolay! ',
          subList: null
        },
        {
          paragraph:
            'İş yeri sigortası sorgulaması yapmak için bilgilerinizi sigorta danışmanlarımıza iletebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'İş yeri sigortası teklifi almak isteyen müşterilerimiz alaokasko.com üzerinden başvuru formu doldurabilir veya 0216 371 67 77 numaralı hattan uzman danışmanımızla iletişime geçerek iş yeri sigortası hakkında detaylı bilgi edinebilir. Size özel hazırlanacak teklifleri değerlendirerek sigorta poliçesi satın alabilir ve iş yerinizi risklere karşı güvence altına alabilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
